export const parseType = (params: any[] = []) =>
  (Array.isArray(params) ? params : []).map(item => {
    return item?.value === 1 ? 'CD' : 'Loja'
  })

export const parse = (params: any[] = []) =>
  (Array.isArray(params) ? params : []).map(item => item?.value)
export const parseNumber = (params: any[] = []) =>
  (Array.isArray(params) ? params : []).map(item => Number(item?.value))

export const parseSomeOne = (params: any[] = []) =>
  (Array.isArray(params) ? params : []).map(item => {
    if (item && typeof item.value === 'number') {
      if (item.value === 0) {
        return item.value + 1
      } else if (item.value === 1) {
        return item.value + 2
      } else {
        return item.value
      }
    } else {
      console.warn("Item doesn't have a valid 'value' property:", item)
      return item
    }
  })

export const parseUnic = (params: any = {}) => params?.value

export const parseAllString = (params: any[] = []) =>
  (Array.isArray(params) ? params : []).map(item => item?.label || '')

export const parseArray = (params: any[] = []) =>
  (Array.isArray(params) ? params : [])
    .map(subArray => subArray?.value?.concat() || [])
    .reduce((a, b) => a.concat(b), [])

export default {
  parse,
  parseSomeOne,
  parseUnic,
  parseType,
  parseAllString,
  parseArray,
  parseNumber
}
